// /before 20-5-2026
// import React, { useEffect, useState } from 'react';
// import { Col, Container, Row } from 'react-bootstrap';
// import { Link, useParams } from 'react-router-dom';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { useTheme } from '@mui/material/styles';
// import { useDispatch, useSelector } from 'react-redux';
// import { Button, CircularProgress } from '@mui/material';
// import DoneIcon from '@mui/icons-material/Done';
// import moment from 'moment-timezone';

// import IconButton from '@mui/material/IconButton';
// import FilledInput from '@mui/material/FilledInput';
// import InputLabel from '@mui/material/InputLabel';
// import InputAdornment from '@mui/material/InputAdornment';
// import FormControl from '@mui/material/FormControl';
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';
// import { Change_Password_Action, Get_One_user_data } from '../Redux/Actions/AuthAction';
// import { Notify } from '../Utility/Notify';
// export const ChangePasswordPage = () => {
//   const { id } = useParams();

//   const dispatch = useDispatch();
//   const [showPasswordold, setShowPasswordold] = React.useState(false);
//   const handleClickShowPassword = () => setShowPasswordold((show) => !show);
//   const [changePasswordLoading, setChangePasswordLoading] = useState(false);

//   const [showPasswordnew, setShowPasswordnew] = React.useState(false);
//   const handleClickShowPasswordnew = () => setShowPasswordnew((show) => !show);

//   const [showPasswordconfirm, setShowPasswordconfirm] = React.useState(false);
//   const handleClickShowPasswordconfirm = () => setShowPasswordconfirm((show) => !show);

//   const handleMouseDownPassword = (event) => {
//     event.preventDefault();
//   };

//   const handleMouseUpPassword = (event) => {
//     event.preventDefault();
//   };

//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark

//   //   const[oldpassword,setoldpassword]=useState('')
//   const [newpassword, setnewpassword] = useState('');
//   const [confirmnewpassword, setconfirmnewpassword] = useState('');
//   const [loading, setloading] = useState(true);

//   useEffect(() => {
//     setnewpassword('');
//     setconfirmnewpassword('');
//   }, []);
//   //       const handleoldpasswordChange=(e)=>{
//   // setoldpassword(e.target.value)
//   //       }

//   const handlenewpasswordchane = (e) => {
//     setnewpassword(e.target.value);
//   };

//   const handleconfirmpasswordchange = (e) => {
//     setconfirmnewpassword(e.target.value);
//   };
//   const [userData, setUserData] = useState(null);
//   const [passwordChangeAt, setPasswordChangeAt] = useState('');

//   // جلب بيانات المستخدم عند تحميل المكون
//   useEffect(() => {
//     const fetchUserData = async () => {
//       await dispatch(Get_One_user_data(id));
//     };
//     fetchUserData();
//   }, [dispatch, id]); // إضافة `dispatch` و `id` كاعتمادات

//   // جلب البيانات من Redux Store
//   const resUserData = useSelector((state) => state.AuthRoot.get_one_user_array);

//   // تحديث حالة userData عند تغير البيانات القادمة من الـ Store
//   useEffect(() => {
//     if (resUserData?.data) {
//       setUserData(resUserData.data);
//     } else {
//       setUserData(null);
//     }
//   }, [resUserData]);

//   // تحديث passwordChangeAt عند تغيير بيانات المستخدم
//   useEffect(() => {
//     if (userData?.passwordChangedAt) {
//       setPasswordChangeAt(userData.passwordChangedAt);
//     }
//   }, [userData]);

//   // change password

//   const submitchangepassword = async (e) => {
//     e.preventDefault();

//     if (confirmnewpassword !== newpassword) {
//       Notify('error', 'Password do not match Confirmition', 'error');
//       return;
//     } else {
//       setloading(true);
//       setChangePasswordLoading(true);
//       await dispatch(
//         Change_Password_Action(id, {
//           // currentPassword: oldpassword,
//           password: newpassword,
//           // passwordConfirm: confirmnewpassword,
//         }),
//       );
//       setloading(false);
//       setChangePasswordLoading(false);
//     }
//   };

//   const reschangepass = useSelector((state) => state.AuthRoot.Change_Password_Array);

//   useEffect(() => {
//     if (loading === false) {
//       if (reschangepass && reschangepass.status === 200) {
//         Notify('success', 'Password Changed Successfully', 'success');

//         setnewpassword('');
//         setconfirmnewpassword('');
//       }
//     }
//   }, [loading]);

//   return (
//     <Container className="startpage">
//       <Row>
//         <Col sm={2}></Col>

//         <Col sm={10}>
//           <Link to={`/AllLeadsForAdmin`} style={{ textDecoration: 'none', color: '#102dff' }}>
//             <span style={{ fontWeight: 'bold' }}>Home</span>
//           </Link>{' '}
//           <KeyboardDoubleArrowRightIcon />{' '}
//           <Link
//             to={`/Users`}
//             style={{ color: mode === 'dark' ? '#ffffff' : '#000000', textDecoration: 'none' }}
//           >
//             <span style={{ color: '#666' }}>Users</span>
//           </Link>{' '}
//           <KeyboardDoubleArrowRightIcon /> <span style={{ color: '#666' }}>Change Password</span>
//           <div className="my-2" style={{ color: '#666' }}>
//             Last Updated At :
//             {passwordChangeAt
//               ? moment(passwordChangeAt).format('DD/MM/YYYY h:mm A')
//               : userData?.createdAt
//                 ? moment(userData.createdAt).format('DD/MM/YYYY h:mm A')
//                 : null}
//           </div>
//           <div
//             style={{
//               background: mode === 'dark' ? '#333' : '#fff',
//               borderRadius: '15px',
//               padding: '25px',
//             }}
//           >
//             {/* <FormControl  sx={{ m: 1, width: '100%' }} variant="filled">
//           <InputLabel htmlFor="filled-adornment-password">Old Password</InputLabel>
//           <FilledInput
//             id="filled-adornment-password-old"
//             type={showPasswordold ? 'text' : 'password'}
//             value={oldpassword}
//             onChange={handleoldpasswordChange}
//             endAdornment={
//               <InputAdornment position="end">
//                 <IconButton
//                   aria-label={
//                     showPasswordold ? 'hide the password' : 'display the password'
//                   }
//                   onClick={handleClickShowPassword}
//                   onMouseDown={handleMouseDownPassword}
//                   onMouseUp={handleMouseUpPassword}
//                   edge="end"
//                 >
//                   {showPasswordold ? <VisibilityOff /> : <Visibility />}
//                 </IconButton>
//               </InputAdornment>
//             }
//           />
//         </FormControl>
//          */}

//             <FormControl sx={{ width: '100%' }} variant="filled">
//               <InputLabel htmlFor="filled-adornment-password">New Password</InputLabel>
//               <FilledInput
//                 id="filled-adornment-password-new"
//                 type={showPasswordnew ? 'text' : 'password'}
//                 value={newpassword}
//                 onChange={handlenewpasswordchane}
//                 endAdornment={
//                   <InputAdornment position="end">
//                     <IconButton
//                       aria-label={showPasswordnew ? 'hide the password' : 'display the password'}
//                       onClick={handleClickShowPasswordnew}
//                       onMouseDown={handleMouseDownPassword}
//                       onMouseUp={handleMouseUpPassword}
//                       edge="end"
//                     >
//                       {showPasswordnew ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 }
//               />
//             </FormControl>

//             <FormControl sx={{ width: '100%' }} variant="filled" className="my-3">
//               <InputLabel htmlFor="filled-adornment-password">Confirm Password</InputLabel>
//               <FilledInput
//                 id="filled-adornment-password-confirm"
//                 type={showPasswordconfirm ? 'text' : 'password'}
//                 value={confirmnewpassword}
//                 onChange={handleconfirmpasswordchange}
//                 endAdornment={
//                   <InputAdornment position="end">
//                     <IconButton
//                       aria-label={
//                         showPasswordconfirm ? 'hide the password' : 'display the password'
//                       }
//                       onClick={handleClickShowPasswordconfirm}
//                       onMouseDown={handleMouseDownPassword}
//                       onMouseUp={handleMouseUpPassword}
//                       edge="end"
//                     >
//                       {showPasswordconfirm ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 }
//               />
//             </FormControl>

//             {/* <Button style={{marginTop:'20px'}} onClick={submitchangepassword} variant="contained" className='w-100'><DoneIcon/> Update</Button> */}
//             <div className="w-100 d-flex justify-content-center">
//               <Button
//                 style={{ marginTop: '20px', background: '#102dff' }}
//                 onClick={!changePasswordLoading ? submitchangepassword : null}
//                 variant="contained"
//                 className=" w-50"
//                 disabled={changePasswordLoading}
//                 startIcon={
//                   changePasswordLoading ? (
//                     <CircularProgress
//                       size={18}
//                       style={{ background: '#102dff', color: mode === 'dark' ? 'white' : 'white' }}
//                     />
//                   ) : (
//                     <DoneIcon />
//                   )
//                 }
//               >
//                 {changePasswordLoading ? 'Updating...' : 'Update'}
//               </Button>
//             </div>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };




































// 20-5-2026
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress, IconButton, InputAdornment, FilledInput, FormControl, InputLabel } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import DoneIcon from '@mui/icons-material/Done';
import moment from 'moment-timezone';
import { Change_Password_Action, Get_One_user_data } from '../Redux/Actions/AuthAction';
import { Notify } from '../Utility/Notify';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

export const ChangePasswordPage = () => {
  const { id }       = useParams();
  const dispatch     = useDispatch();
  const navigate     = useNavigate();
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const sidebarWidth = useSidebarWidth();

  const [newpassword,        setnewpassword]        = useState('');
  const [confirmnewpassword, setconfirmnewpassword] = useState('');
  const [showNew,            setShowNew]            = useState(false);
  const [showConfirm,        setShowConfirm]        = useState(false);
  const [loading,            setLoading]            = useState(true);
  const [sending,            setSending]            = useState(false);
  const [userData,           setUserData]           = useState(null);
  const [passwordChangeAt,   setPasswordChangeAt]   = useState('');

  /* fetch user */
  useEffect(() => {
    dispatch(Get_One_user_data(id));
  }, [dispatch, id]);

  const resUserData = useSelector((s) => s.AuthRoot.get_one_user_array);
  useEffect(() => {
    if (resUserData?.data) setUserData(resUserData.data);
  }, [resUserData]);
  useEffect(() => {
    if (userData?.passwordChangedAt) setPasswordChangeAt(userData.passwordChangedAt);
  }, [userData]);

  /* submit */
  const submitchangepassword = async (e) => {
    e.preventDefault();
    if (confirmnewpassword !== newpassword)
      return Notify('error', 'Passwords do not match', 'error');
    setLoading(true);
    setSending(true);
    await dispatch(Change_Password_Action(id, { password: newpassword }));
    setLoading(false);
    setSending(false);
  };

  const reschangepass = useSelector((s) => s.AuthRoot.Change_Password_Array);
  useEffect(() => {
    if (loading === false) {
      if (reschangepass?.status === 200) {
        Notify('success', 'Password Changed Successfully', 'success');
        setnewpassword('');
        setconfirmnewpassword('');
      }
      setLoading(true);
    }
  }, [loading]);

  /* password strength */
  const getStrength = (pwd) => {
    if (!pwd) return null;
    if (pwd.length < 6) return { label: 'Too short', color: '#ef4444', width: '25%' };
    if (pwd.length < 8) return { label: 'Weak', color: '#f97316', width: '50%' };
    if (!/[A-Z]/.test(pwd) || !/[0-9]/.test(pwd)) return { label: 'Medium', color: '#eab308', width: '75%' };
    return { label: 'Strong', color: '#22c55e', width: '100%' };
  };
  const strength = getStrength(newpassword);

  /* shared input field styles */
  const fieldSx = {
    '& .MuiFilledInput-root': {
      borderRadius: '10px',
      backgroundColor: isDark ? '#151827' : '#f8fafc',
      border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
      '&:before, &:after': { display: 'none' },
      '&:hover': { backgroundColor: isDark ? '#1a1f35' : '#f1f5f9' },
      '&.Mui-focused': {
        backgroundColor: isDark ? '#1a1f35' : '#ffffff',
        border: '1.5px solid #2563eb',
        boxShadow: '0 0 0 3px rgba(37,99,235,0.12)',
      },
    },
    '& .MuiFilledInput-input': {
      color: isDark ? '#f1f5f9' : '#0f172a',
      fontFamily: "'DM Sans', sans-serif",
      fontSize: '14px',
      padding: '20px 16px 8px',
    },
    '& .MuiInputLabel-root': {
      color: isDark ? '#6b7280' : '#94a3b8',
      fontFamily: "'DM Sans', sans-serif",
      fontSize: '13px',
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#2563eb' },
    '& .MuiIconButton-root': { color: isDark ? '#6b7280' : '#94a3b8' },
  };

  const lastUpdated = passwordChangeAt
    ? moment(passwordChangeAt).format('MMM DD, YYYY • h:mm A')
    : userData?.createdAt
    ? moment(userData.createdAt).format('MMM DD, YYYY • h:mm A')
    : null;

  return (
    <div style={{
      position: 'fixed',
      top: '50px', left: sidebarWidth, right: 0, bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', flexWrap: 'wrap',
      }}>
        <Link to="/AllLeadsForAdmin" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Home
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <Link to="/Users" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Users
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Change Password</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%', maxWidth: '560px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px', padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{
              fontSize: '22px', fontWeight: 700,
              color: isDark ? '#f1f5f9' : '#0d1b3e',
              margin: '0 0 4px', letterSpacing: '-0.4px',
            }}>
              Change Password
            </h1>
            {lastUpdated && (
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: '6px',
                marginTop: '8px', padding: '5px 12px', borderRadius: '8px',
                background: isDark ? '#151827' : '#f8fafc',
                border: `1px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                fontSize: '12px', color: isDark ? '#6b7280' : '#94a3b8',
              }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                </svg>
                Last updated: <strong style={{ color: isDark ? '#9ca3af' : '#64748b' }}>{lastUpdated}</strong>
              </div>
            )}
          </div>

          {/* New Password */}
          <div style={{ marginBottom: '16px' }}>
            <FormControl fullWidth variant="filled" sx={fieldSx}>
              <InputLabel>New Password</InputLabel>
              <FilledInput
                type={showNew ? 'text' : 'password'}
                value={newpassword}
                onChange={(e) => setnewpassword(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowNew(s => !s)} edge="end" size="small">
                      {showNew ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>

            {/* strength bar */}
            {strength && (
              <div style={{ marginTop: '8px' }}>
                <div style={{
                  height: '4px', borderRadius: '4px',
                  background: isDark ? '#2d3248' : '#e2e8f0', overflow: 'hidden',
                }}>
                  <div style={{
                    height: '100%', width: strength.width,
                    background: strength.color,
                    transition: 'width 0.3s ease, background 0.3s ease',
                    borderRadius: '4px',
                  }} />
                </div>
                <span style={{ fontSize: '11px', color: strength.color, fontWeight: 600, marginTop: '4px', display: 'block' }}>
                  {strength.label}
                </span>
              </div>
            )}
          </div>

          {/* Confirm Password */}
          <div style={{ marginBottom: '8px' }}>
            <FormControl fullWidth variant="filled" sx={fieldSx}>
              <InputLabel>Confirm Password</InputLabel>
              <FilledInput
                type={showConfirm ? 'text' : 'password'}
                value={confirmnewpassword}
                onChange={(e) => setconfirmnewpassword(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') submitchangepassword(e); }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowConfirm(s => !s)} edge="end" size="small">
                      {showConfirm ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>

            {/* match indicator */}
            {confirmnewpassword && (
              <p style={{
                fontSize: '12px', marginTop: '6px', fontWeight: 600,
                color: confirmnewpassword === newpassword ? '#22c55e' : '#ef4444',
              }}>
                {confirmnewpassword === newpassword ? '✓ Passwords match' : '✗ Passwords do not match'}
              </p>
            )}
          </div>

          {/* hint */}
          <p style={{ fontSize: '12px', color: isDark ? '#4b5563' : '#94a3b8', margin: '8px 0 0' }}>
            Use at least 8 characters with uppercase letters and numbers
          </p>

          {/* divider */}
          <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '28px 0' }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!sending ? submitchangepassword : null}
              disabled={sending}
              type="button"
              style={{
                flex: 1, padding: '14px 24px', borderRadius: '10px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: sending ? 'not-allowed' : 'pointer',
                opacity: sending ? 0.7 : 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                if (!sending) {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)';
              }}
            >
              {sending
                ? <><CircularProgress size={16} style={{ color: '#fff' }} /><span>Updating…</span></>
                : <><DoneIcon sx={{ fontSize: 17 }} /><span>Update Password</span></>}
            </button>

            <button
              type="button"
              onClick={() => navigate('/Users')}
              style={{
                padding: '14px 28px', borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: 'pointer', transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8';
                e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0';
                e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b';
              }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};
